<div class="dropdown-container">
	<app-single-select-dropdown
		[opties]="filteredDropDownOptions"
		[selectedOptie]="findDropDownOption(selectie)"
		[placeholder]="placeholder"
		[showSearchInput]="true"
		(onSearchInput)="filter($event)"
		(onOptieClicked)="selectieChange.emit($event)"
		[searchInput]="zoek"
		[enabled]="enabled"
	></app-single-select-dropdown>
</div>
